import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

function SummarySearchBar({
  value,
  onChange,
  placeholder = "Search...",
  debounceMs = 350,
}) {
  const [localValue, setLocalValue] = useState(value || "");
  const timerRef = useRef(null);

  // Sync state if prop changes from outside
  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleChange = (e) => {
    const nextVal = e.target.value;
    setLocalValue(nextVal);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onChange(nextVal);
    }, debounceMs);
  };

  const handleClear = () => {
    setLocalValue("");
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    onChange("");
  };

  const handlePressEnter = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    onChange(localValue);
  };

  return (
    <div className="optimisation-review__summary-search-wrap">
      <Input
        allowClear
        value={localValue}
        onChange={handleChange}
        onPressEnter={handlePressEnter}
        onClear={handleClear}
        suffix={<SearchOutlined style={{ color: '#8a94a6', fontSize: '16px' }} />}
        placeholder={placeholder}
        className="optimisation-review__summary-search"
      />
    </div>
  );
}

export default React.memo(SummarySearchBar);
